export default {
  update_time_lower: 'Update time:',
  on_is_page: 'On this page',
  most_viewed_doc: 'Most Viewed Documentation',
  quick_access: 'Quick Access',
  tencent_games_in_game: 'Tencent Games InGame',

  documentation_portal: 'Documentation Portal',
  document_get_started: 'Get Started',
  document_product: 'Product',
  document_home_des:
    'Everything about InGame is here. The Documentation Portal helps you to get familiar with ingame and helps you to complete your game more easily and quickly!',
  document_home_question: 'If you still have another question, please ',
  document_home_contact: 'Contact Us',
  get_started_des: 'Helps you get started with InGame faster',
  portal_manual_des: 'Basic information about Devportal',
  services_manual_des:
    'User guides for all of InGame\'s services, with more services still to come!',
  tools_manual_des:
    'We recommend that technicians take a deeper understand on our SDKs and tools.',
  demo_tutorials_des: 'A guide to playing our demo game.',
  knowledge_base_des:
    'For a summary of the difficulties in Devportal, we have made a summary here',
  update_history_des: 'All about InGame version updates',

  services_manual_tips:
    'Click on any of the service area below to learn more about how they function and can be used in your game.',
  multiplayer_content:
    'Focus on the core capabilities of game backends, build a multiplayer online game ecosystem, covering core supporting capabilities including player management, matching, battles, and automated tasks.',
  social_content:
    'Create the game\'s own social circle, enable players from different platforms to interact and communicate in the game, and provide players with social-related services such as friend management, text chat, guilds, and leaderboards.',
  economy_content:
    'Build a long-term operational game ecosystem, empowering game developers by integrating rich R&D and operation experience on mobile terminals and mature online game operation models.',
  engage_content:
    'Shorten the feedback loop between game development and player satisfaction, promote connections with players, and enhance player retention to maintain the game\'s appeal and fun.',
  content_content:
    'Build cross-platform universal content distribution technology to meet the version content update demands of games during the long-term GaaS operational phase.',
  analytics_content:
    'Build a data analysis and monitoring system to assist users in game analysis and performance monitoring. It not only helps to further understand players and provide more engaging experiences but also ensures the safe and stable operation of the game and supports decision-making.',
  services_item_btn: 'Explore Content',
  content_no_per_first: 'You are not authenticated to view this document',
  content_no_per_second_left: 'If you want to view it, please',
  content_no_per_second_right: 'to InGame platform first.',
  content_no_per_second_login: 'login',
  search_results_total: 'There are {{total}} search results in total.',
};
